import { FC, useState } from 'react';
import { Typography } from '@mui/material';
import Chip from '@mui/material/Chip';

interface SupplierChipsProps {
  list: any
  setSelectedChip:any
  hasMessageAfter:any
}

const SupplierChips: FC<SupplierChipsProps> = ({ list, setSelectedChip, hasMessageAfter }) => {
    const [selectedSupplier, setSelectedSupplier] = useState<string | null>(null);

    const handleChipClick = async (supplierNumber: string) => {
        setSelectedSupplier(supplierNumber);
        await setSelectedChip(supplierNumber);
    };


  return (
    <>
    { <Typography sx={{color:'green', padding:3}}>These are the supplier results we found, please click on the supplier you need to choose</Typography> }
        <Typography style={{ whiteSpace: 'pre-line' }}>
              {list.map((s: any, key: any) => (
                <Chip
                    sx={{margin:1}}
                    key={key}
                    label={`${s.supplierName} ${s.supplierNumber}`}
                    aria-pressed={selectedSupplier === s.supplierNumber}
                    disabled={hasMessageAfter}
                    onClick={() => handleChipClick(s.supplierNumber)}
                />
            ))}
    </Typography>
    </>

    
  );
};

export default SupplierChips;
